import { MRT_ColumnDef } from 'mantine-react-table';
import { Text } from '@mantine/core';
import type { CSSProperties } from 'react';
import { formatPriceWithoutCurrency } from 'app/utils/util-functions';

const getTextStyle = (weight: number, lineHeight: string, isTotal: boolean, textAlign?: 'start' | 'end' | 'center'): CSSProperties => ({
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '14px',
    fontWeight: weight,
    lineHeight: lineHeight,
    textAlign: textAlign ?? 'center',
    color: isTotal ? '#3F036D' : '#413E3E',
    width: '100%',
});

function TableHead({ header, textAlign }: { header: string, textAlign?: 'start' | 'end' | 'center' }) {
    return (
        <Text style={getTextStyle(700, '22px', false, textAlign)}>
            {header}
        </Text>
    );
}

export const columnDefsAccrualFeeCalculation: MRT_ColumnDef<any>[] = [
    {
        header: 'Date',
        accessorKey: 'effectiveDate',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },
        mantineTableBodyCellProps: ({ row }) => ({
            sx: row.original.effectiveDate === "Total"
                ? {
                    '&:hover': {
                        background: '#F7F7F7 !important',
                    },
                    background: "#F7F7F7 !important",

                }
                : {}
        }),
        size: 100,
        Header: () => (
            <TableHead header={'Date'} textAlign='start' />
        ),
        Cell: ({ cell, row }) => {
            return (
                <div>
                    <Text style={{ ...getTextStyle(600, '19px', row.original.effectiveDate === "Total"), textAlign: 'start' }}>
                        {cell.getValue<string>()}
                    </Text>
                </div >
            );
        },
    },
    {
        header: 'Total',
        size: 55,
        accessorKey: 'total',
        mantineTableBodyCellProps: ({ row }) => ({
            sx: row.original.effectiveDate === "Total"
                ? {
                    '&:hover': {
                        background: '#F7F7F7 !important',
                    },
                    background: "#F7F7F7 !important",
                    borderRight: "1px solid #CAC9C9 !important",

                }
                : {
                    borderRight: "1px solid #CAC9C9 !important",
                },
        }),

        mantineTableHeadCellProps: {
            className: 'cell-width-100',
            sx: { borderRight: "1px solid #CAC9C9 !important", background: "#F0EEEE" },
        },
        Header: () => (
            <TableHead header={'Total'} textAlign='end' />
        ),
        Cell: ({ cell, row }) => {
            const amount = Number(cell.getValue<string>() ?? '')
            const formattedAmount = formatPriceWithoutCurrency(Math.abs(amount), 2, 2)
            const isTotal = row.original.effectiveDate === "Total"

            return (
                <div>
                    <Text style={{ ...getTextStyle(600, '19px', isTotal), textAlign: 'end' }}>
                        {amount < 0 ? `(${formattedAmount})` : formattedAmount}
                    </Text>
                </div>
            );
        },

    },
    {
        header: 'Economic Benefit',
        accessorKey: 'Economic Benefit',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },
        mantineTableBodyCellProps: ({ row }) => ({
            sx: row.original.effectiveDate === "Total"
                ? {
                    '&:hover': {
                        background: '#F7F7F7 !important',
                    },
                    background: "#F7F7F7 !important",

                }
                : {}
        }),
        size: 55,
        Header: () => (
            <TableHead header={'Economic Benefit'} textAlign='end' />
        ),
        Cell: ({ cell, row }) => {
            const amount = Number(cell.getValue<string>() ?? '')
            const formattedAmount = formatPriceWithoutCurrency(Math.abs(amount), 2, 2)
            const isTotal = row.original.effectiveDate === "Total"

            return (
                <div>
                    <Text style={{ ...getTextStyle(600, '19px', isTotal), textAlign: 'end' }}>
                        {amount < 0 ? `(${formattedAmount})` : formattedAmount}
                    </Text>
                </div>
            );
        },
    },
    {
        header: 'Delayed Compensation',
        accessorKey: 'Delayed Compensation',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },
        mantineTableBodyCellProps: ({ row }) => ({
            sx: row.original.effectiveDate === "Total"
                ? {
                    '&:hover': {
                        background: '#F7F7F7 !important',
                    },
                    background: "#F7F7F7 !important",

                }
                : {}
        }),
        size: 170,
        Header: () => (
            <TableHead header={'Delayed Compensation'} textAlign='end' />
        ),
        Cell: ({ cell, row }) => {
            const amount = Number(cell.getValue<string>() ?? '')
            const formattedAmount = formatPriceWithoutCurrency
                (Math.abs(amount), 2, 2)

            const isTotal = row.original.effectiveDate === "Total"

            return (
                <div>
                    <Text style={{ ...getTextStyle(600, '19px', isTotal), textAlign: 'end' }}>
                        {amount < 0 ? `(${formattedAmount})` : formattedAmount}
                    </Text>
                </div>
            );
        },
    },
    {
        header: 'Cost of Carry',
        accessorKey: 'Cost of Carry',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },
        mantineTableBodyCellProps: ({ row }) => ({
            sx: row.original.effectiveDate === "Total"
                ? {
                    '&:hover': {
                        background: '#F7F7F7 !important',
                    },
                    background: "#F7F7F7 !important",

                }
                : {}

        }),
        size: 55,
        Header: () => (
            <TableHead header={'Cost of Carry'} textAlign='end' />
        ),
        Cell: ({ cell, row }) => {
            const amount = Number(cell.getValue<string>() ?? '')
            const formattedAmount = formatPriceWithoutCurrency(Math.abs(amount), 2, 2)
            const isTotal = row.original.effectiveDate === "Total"


            return (
                <div>
                    <Text style={{ ...getTextStyle(600, '19px', isTotal), textAlign: 'end' }}>
                        {amount < 0 ? `(${formattedAmount})` : formattedAmount}
                    </Text>
                </div>
            );
        },
    },


];
